import { IoSchool } from "react-icons/io5";
import { useGlobalContext } from "./context/globalContext";
import React, { useState, useRef, useEffect } from "react";
import { MdHealthAndSafety } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { FaMapLocation } from "react-icons/fa6";

const LocationBenefits2 = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };
  const benefits = [
    {
      icon: <IoSchool />,
      title: "Educational Institutes",
      details: [
        "Shishu Vihar Scl - 800 m",
        "DY Patil Intl Scl Worli - 1.7 Km",
        "JBCN Intl Scl - 1.9 Km",
        "Don Bosco Intl Scl - 4.7 Km",
      ],
    },
    {
      icon: <MdHealthAndSafety />,
      title: "Hospitals",
      details: [
        "KEM Hospital - 400 m",
        "Global Hospital - 700 m ",
        "Wadia Hospital - 1.4 Km",
        "Hinduja Hospital - 5.6 Km ",
      ],
    },
    {
      icon: <FaShoppingCart />,
      title: "Malls",
      details: [
        "Kamla Mills - 1.4 Km",
        "Phoenix Mall & Palladium - 2.7 Km",
        "Phoenix Market City - 2.9 Km",
        "Atria Mall - 3.3 Km",
      ],
    },
    {
      icon: <FaMapLocation />,
      title: "Connectivity",
      details: [
        "Curry Road Station - 950 m",
        "Lower Parel Station - 1.9 Km",
        "Coastal Road - 6 Km",
        "Atal Setu - 6.5 Km",
      ],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.PNG" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                {project} - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {/* {benefit.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))} */}
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" - "); // Using " - " (en dash) for separation
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>

                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; // Handle cases with no " - "
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span className="new-button " onClick={handleShowModal}>
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
